exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mailing-list-index-js": () => import("./../../../src/pages/mailing-list/index.js" /* webpackChunkName: "component---src-pages-mailing-list-index-js" */)
}

